/**
 * Status Codes
 *
 * Represents specific status identifiers within a category.
 * These are system-wide constants that represent the actual workflow states.
 *
 * Mirrors backend Status.Code values from cases.statuses seed data.
 *
 * Note: Category codes (StatusCategoryCode) group statuses:
 * - Open category: new, assigned, in_progress, pending_info
 * - Closed category: resolved, closed
 */
export enum StatusCode {
  /** Newly submitted case awaiting initial review (Open category) */
  New = 'new',

  /** Case has been assigned to an HR agent (Open category) */
  Assigned = 'assigned',

  /** Case is actively being worked on (Open category) */
  InProgress = 'in_progress',

  /** Waiting for additional information from requestor (Open category) */
  PendingInfo = 'pending_info',

  /** Case has been resolved and solution provided (Closed category) */
  Resolved = 'resolved',

  /** Case has been closed (Closed category) */
  Closed = 'closed',
}
